import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, useTheme, useMediaQuery } from '@mui/material';

const PitchInboxTabs = ({ tabs, activeTab, onTabChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Tabs
      value={activeTab}
      onChange={onTabChange}
      variant={isMobile ? 'fullWidth' : 'scrollable'}
      scrollButtons={!isMobile ? 'auto' : false}
      allowScrollButtonsMobile={!isMobile}
      sx={{
        position: 'relative',
        minHeight: { xs: '40px', sm: '60px' },
        '& .MuiTab-root': {
          minHeight: { xs: '40px', sm: '60px' },
          py: { xs: 0.25, sm: 0.5 },
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '2px',
          backgroundColor: '#e0e0e0',
        },
        '& .MuiTabs-indicator': {
          zIndex: 2,
        },
      }}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <Tab
            key={tab.label}
            value={tab.id}
            icon={<Icon />}
            iconPosition="start"
            label={isMobile ? '' : tab.label}
            sx={{
              px: { xs: '8px', sm: '32px' },
              fontSize: { xs: '0.75rem', sm: '1rem' },
              fontWeight: 'bold',
              color: 'text.primary',
              backgroundColor: activeTab === tab.id ? '#ecf3fd' : 'transparent',
              '& .MuiTab-iconWrapper': {
                fontSize: { xs: '1.25rem', sm: '1.2rem' },
                marginBottom: '0 !important',
                marginRight: { xs: '0', sm: '8px' },
              },
            }}
          />
        );
      })}
    </Tabs>
  );
};

PitchInboxTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default PitchInboxTabs;
